"use client";

import type { ModelsNewsCard } from "../../../types";
import { NewsCard } from "../../common/news-card";
import { newsFeaturedVariant } from "./news-list.variants";
import NewsFeaturedSideCards from "./news-featured-side-cards";

export interface NewsFeaturedProps {
  sideCards: ModelsNewsCard[];
  mainCard: ModelsNewsCard;
}

function NewsFeatured({ sideCards, mainCard }: NewsFeaturedProps) {
  const styles = newsFeaturedVariant();
  const highlight = mainCard || sideCards[0];

  const hasSideCards = sideCards.length > 0;

  return (
    <div className={styles.base()}>
      <div className={styles.content()}>
        <div className={styles.left()}>
          {!!highlight && <NewsCard {...highlight} highlight={true} />}
        </div>
        <div className={styles.right()}>
          {hasSideCards && <NewsFeaturedSideCards cards={sideCards} />}
        </div>
      </div>
    </div>
  );
}

export default NewsFeatured;
